import api from "../../utils/api";
import { DOCUMENTS_URL } from "../../utils/endpoints";

export async function getDocumentDownload(id: string | number) {
  try {
    const response = await api.get(`${DOCUMENTS_URL}/${id}/download`, {
      responseType: "blob",
    });

    return { data: response.data };
  } catch (error) {
    throw error;
  }
}
